export const formatRows = (listaItems) => 
  listaItems.map((item) => ({
    id: item.id ?? "Id no disponible",
    categ_descripcion: item.categ_descripcion || "Descripción de categoría no disponible",
  }));
